import { entries } from "./entries";
import { Dictionary } from "./types";

export function map<Value = any, Result = any>(target: Array<Value>, executor: (key: number, value: Value) => Result): Array<Result>;
export function map<Value = any, Result = any>(target: Dictionary<Value>, executor: (key: number, value: Value) => Result): Array<Result>;
export function map<Key extends string | number | symbol, Value = any, Result = any>(target: Record<Key, Value>, executor: (key: number, value: Value) => Result): Array<Result>;

/**
 * Find index and/or value within an Object or an Array that returns true for the predicate
 */
export function map(target: any, executor: (key: any, value: any) => any) {
	const results = [];

	for (const [currentKey, currentValue] of entries(target)) {
		results.push(executor(currentKey, currentValue));
	}

	return results;
}